import React from "react";
import './Navbar.css';
import ArdesLogo from '../../Assets/adreslabslogo.png';
import { NavLink, useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { motion,useCycle } from "framer-motion";

const variantsul = {
    open: {
      transition: { staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
      transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
  };

const variants = {
    open: {
      y: 0,
      opacity: 1,
      transition: {
        y: { stiffness: 1000, velocity: -100 }
      }
    },
    closed: {
      y: 50,
      opacity: 0,
      transition: {
        y: { stiffness: 1000 }
      }
    }
  };


function Navbar(){
    const navigate = useNavigate()
    const [isOpen,toggleOpen] = useCycle(false,true);
    return(
        <>
            <div className="navbar">
                <div className="navbar-container">
                    <div className="navbar-logo" onClick={()=>navigate('/')}>
                        <img src={ArdesLogo} alt='ardeslogo'/>
                    </div>
                    <ul className="navbar-listitems">
                        <NavLink to='/'>
                            <li>home</li>
                        </NavLink>
                        <NavLink to='/aboutus'>
                            <li>about us</li>
                        </NavLink>
                        <NavLink to='/ourscience'>
                            <li>our science</li>
                        </NavLink>
                        <NavLink to='/services'>
                            <li>services</li>
                        </NavLink>
                        <NavLink to='/career'>
                            <li>career</li>
                        </NavLink>
                    </ul>
                    <div className="navbar-contactus">
                        <NavLink to='/contactus'>
                        <p style={{cursor:'pointer'}}>contact us</p>
                        </NavLink>
                        
                    </div>
                    <div className="navbar-menuicon" onClick={()=>toggleOpen()}>
                        {isOpen?<CloseIcon/>:<MenuIcon/>}
                    </div>

                    <div className={`navbar-sidebar ${isOpen?"sidebar-active":"sidebar-inactive"}`}>
                    <motion.ul animate={isOpen?"open":"closed"} variants={variantsul} className="sidebar-unorderlist">
                        <NavLink to='/'>
                            <motion.li
                                variants={variants}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}>
                                Home</motion.li>
                        </NavLink>
                        <NavLink to='/aboutus'>
                        <motion.li 
                            variants={variants}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >about us</motion.li>
                        </NavLink>
                        <NavLink to='/ourscience'>
                            <motion.li
                                variants={variants}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >our science</motion.li>
                        </NavLink>

                        <NavLink to='/services'>
                            <motion.li
                                variants={variants}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >services</motion.li>
                        </NavLink>

                        <NavLink to='/career'>
                            <motion.li
                                variants={variants}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >career</motion.li>
                        </NavLink>

                        <NavLink to='/contactus'>
                            <motion.li
                                variants={variants}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                                >contact us</motion.li>
                        </NavLink>
                    </motion.ul>
                </div>
                </div>
            </div>

            {/* sidebar container */}
            
            
            
            
        </>
    );
}

export default Navbar;